import React, { ReactNode } from 'react';
import styled, { createGlobalStyle } from 'styled-components';

interface ModalProps {
    children: ReactNode;
    dataAuto?: string;
    width?: string;
    disableBodyScroll?: boolean;
    header?: ReactNode;
}

export const Modal = ({
    children,
    dataAuto,
    width = '580px',
    disableBodyScroll,
    header,
}: ModalProps) => (
    <>
        {disableBodyScroll && <DisableScrollStyle />}
        <ModalWrapper data-auto={dataAuto}>
            <ModalSection width={width}>
                {header}
                <ModalContent>{children}</ModalContent>
            </ModalSection>
        </ModalWrapper>
    </>
);

const DisableScrollStyle = createGlobalStyle`
    body {
        overflow: hidden !important;
    }
`;

const ModalWrapper = styled.div`
    position: fixed;
    z-index: 999;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
`;

const ModalSection = styled.div<{ width?: string }>`
    display: flex;
    flex-direction: column;
    gap: 24px;
    background-color: #ffffff;
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    width: ${({ width }) => width};
    overflow: hidden;
    box-sizing: border-box;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);

    @media (max-width: 767px) {
        width: 100%;
        height: 100vh;
        max-height: unset;
        border-radius: 0;
        border: none;
        padding: 20px;
    }
`;

const ModalContent = styled.div`
    max-height: 90vh;
    overflow-y: auto;
    padding: 32px;
    font-weight: 500;
    font-size: 13px;
    box-sizing: border-box;
    position: relative;
    cursor: default;
    font-family: 'Duda Sans', Roboto, sans-serif;
    color: #272b35;

    @media (max-width: 767px) {
        display: flex;
        flex-direction: column;
    }
`;

export const Title = styled.span`
    font-size: 24px;
    font-weight: 700;
`;

export const Divider = styled.hr`
    height: 1px;
    border: none;
    background: #e4e4e6;
    margin: 20px 0;
`;

export const FooterNote = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    gap: 8px;
    margin-block: auto;

    font-size: 16px;
    font-weight: 350;

    span {
        text-decoration: underline;
        cursor: pointer;
        &[data-disabled='true'] {
            pointer-events: none;
            opacity: 0.5;
        }
    }
`;
